/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-undef */
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import POSCustomerScreenButton from "../../../components/POSCustomerScreenButton";
import SocketStatusButton from "../../../components/SocketStatusButton";
import { getGlobalVar } from "../../config/Config";
import NavOrderInside from "./NavOrderInside";

const OrderNav = ({
  itemsInCart,
  setItemsInCart,
  currentCustomer,
  setCurrentCustomer,
  prevCustomer,
  setPrevCustomer,
  prevOrder,
  setPrevOrder,
  allProducts,
  setSearchResults,
  searchTerm,
  setSearchTerm,
  setAllView,
  setCateg1View,
  setCateg2View,
  setTotal,
  sendOrderToBackend,
  setCurrentOrderRef,
  onOrderResume,
  customerData,
}) => {
  const [showPopup, setShowPopup] = useState(false);
  const [user, setUser] = useState(null);
  const [globalVar, setValue] = useState(getGlobalVar());
  const navigate = useNavigate();

  // On Product Search
  const onProductSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchTerm(searchTerm);

    if (searchTerm === "") {
      setSearchResults(allProducts);
    } else {
      const searchResults = allProducts.filter((product) =>
        product.ProductName.toLowerCase().includes(searchTerm)
      );
      setSearchResults(searchResults);
    }
    setAllView(false);
    /* setCateg1View(false); */
    /* setCateg2View(false); */
  };
  return (
    <nav className="row">
      <div className="col-5">
        <img
          className="white"
          src={require("../../../assets/images/posLogo.svg").default}
        />
        <span className="ps bbb ">POS</span>
      </div>
      <div className="col-3 mt-3">
        <button type="default" className=" ">
          <i className="pi pi-shopping-cart ml-2 mr-2"></i>{" "}
          {localStorage.getItem("actualOrderId")
            ? "Order " + localStorage.getItem("actualOrderId")
            : "New order"}
        </button>
        <button
          onClick={() => {
            setShowPopup(true);
          }}
          style={{ borderLeft: "1px solid black" }}
        >
          <i className="pi pi-shopping-cart ml-2 mr-2"></i> Orders
        </button>
      </div>
      <div className="col-4 mt-3">
        <Input
          type="text"
          size="large"
          value={searchTerm || ""}
          // className=" search-box border-l-2  radious"
          placeholder="search"
          onChange={onProductSearch}
          prefix={<SearchOutlined />}
          className="w-50"
        />
        {showPopup ? (
          <NavOrderInside
            itemsInCart={itemsInCart}
            setItemsInCart={setItemsInCart}
            currentCustomer={currentCustomer}
            setCurrentCustomer={setCurrentCustomer}
            prevOrder={prevOrder}
            setPrevOrder={setPrevOrder}
            prevCustomer={prevCustomer}
            setPrevCustomer={setPrevCustomer}
            setShowPopup={setShowPopup}
            showPopup={showPopup}
            setTotal={setTotal}
            user={setUser}
            sendOrderToBackend={sendOrderToBackend}
            allProducts={allProducts}
            setCurrentOrderRef={setCurrentOrderRef}
            customerData={customerData}
          />
        ) : (
          ""
        )}

        <button
          onClick={() => {
            navigate(-1);
          }}
          style={{ float: "right", marginRight: "10px" }}
        >
          <CloseOutlined />
        </button>
        <SocketStatusButton />
        <POSCustomerScreenButton />
      </div>
    </nav>
  );
};
export default OrderNav;
